import type { Field } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/types.tsx';
import type { OldGICPayload } from '../types.tsx';

const CUSTOM_FIELD_PREFIX = 'customfield';

export const filterCustomFields = (payload: OldGICPayload = {}): Field => {
	// customField's id's start with the name customfield https://confluence.atlassian.com/adminjiraserver/advanced-use-of-the-jira-issue-collector-938847349.html
	const fieldsToPrefill = payload?.prefilledFields;
	if (!fieldsToPrefill) return {};
	const prefilledCustomFields: Field = {};
	const systemFieldsToBeIncluded: string[] = [
		'worklog_timeLogged',
		'worklog_startDate',
		'worklog_comment',
		'timetracking_remainingestimate',
		'description',
		'paragraph',
		'environment',
	];
	Object.keys(fieldsToPrefill).forEach((key) => {
		if (key.startsWith(CUSTOM_FIELD_PREFIX) || systemFieldsToBeIncluded.includes(key))
			prefilledCustomFields[key] = fieldsToPrefill[key];
	});
	return prefilledCustomFields;
};
